import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PaymentChannelEnum } from '../enums/payment-channel.enum';
import { PaymentMethodEnum } from '../enums/payment-method.enum';
import { PaymentProviderEnum } from '../enums/payment-provider.enum';

/**
 * Payment DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.PAYMENT)
export class PaymentSearchDto extends BaseSearchDto {
  transactionIds?: number[] | null;
  provider!: PaymentProviderEnum;
  paymentMethod!: PaymentMethodEnum;
  channel!: PaymentChannelEnum;
  externalReference?: string | null;
  externalStatus?: string | null;
  paymentLink?: string | null;
  metadata?: Record<string, any> | null;
  currencyIsoCode!: string;
  amount?: number | null;
  retryCount?: number | null;
  files?: FileDto[] | null;
}
